import { Effect } from "../Materials/effect";
var name = 'lensFlareVertexShader';
var shader = "\nattribute vec2 position;\n\nuniform mat4 viewportMatrix;\n\nvarying vec2 vUV;\nconst vec2 madd=vec2(0.5,0.5);\nvoid main(void) {\nvUV=position*madd+madd;\ngl_Position=viewportMatrix*vec4(position,0.0,1.0);\n}";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var lensFlareVertexShader = { name: name, shader: shader };
//# sourceMappingURL=lensFlare.vertex.js.map